import './responsibility.css'
import Texthome2 from '../../componnets/texthome2/Texthome2'
import responsibility from '../../img/responsibility.gif'
export default function Responsibility(){
    return(
        <div className='responsibilitypage'>
            <img src={responsibility} alt='responsibility' className='responsibilitygif'></img>
            <Texthome2 />
        </div>
    )
}